import { Fragment } from 'react'

interface SuperscriptifyProps {
  /**
   * String that might contain the target 0 or more times to be wrapped.
   */
  children: string
  /**
   * The string to wrap in <sup></sup> node
   */
  target: string
}

/**
 * React Component which accepts a string as its child. Any substring matching
 * the target prop will be rendered in <sup> (superscript) node.
 *
 * e.g.
 * ```tsx
 * <Superscriptify target="1">Unbelievable thingy1 can do it all.</Superscriptify>
 * ```
 * Produces the following
 * ```html
 * Unbelievable thingy<sup>1</sup> can do it all.
 * ```
 */
const Superscriptify: React.FC<SuperscriptifyProps> = ({
  children,
  target
}) => {
  const parts = children.split(new RegExp(target, 'g'))
  const newChildren: Array<React.ReactElement> = []

  let i = 0

  for (; i < parts.length - 1; i += 1) {
    newChildren.push(<Fragment key={parts[i]}>{parts[i]}</Fragment>)
    newChildren.push(<sup key={target}>{target}</sup>)
  }

  newChildren.push(<Fragment key={parts[i]}>{parts[i]}</Fragment>)

  // It is necessary to wrap in a fragment to pass unit tests.
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{newChildren}</>
}

export default Superscriptify
